import { render, staticRenderFns } from "./CreateField.vue?vue&type=template&id=d74f7f1c&scoped=true&"
import script from "./CreateField.vue?vue&type=script&lang=js&"
export * from "./CreateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d74f7f1c",
  null
  
)

export default component.exports